import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { easeCurves } from "../../motion/eases";
import React, { useRef } from 'react';
import styled from 'styled-components';
import { theme, whenActive, whenHovered } from "../../theme";
import { Ripple } from "./Ripple";
import VisuallyHidden from '@reach/visually-hidden';
import { useSharedHoverContext } from "../SharedHover/SharedHoverContext";
import { mergeProps } from '@react-aria/utils';
import { hoverStyles } from "../Interactive/mixins";
import { baseIconButtonStyles } from "../Button/IconButton";
export var RippleIconToggle = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      icon = _ref.icon,
      label = _ref.label,
      isSelected = _ref.isSelected,
      disabled = _ref.disabled,
      selectionColor = _ref.selectionColor,
      _ref$selectedColor = _ref.selectedColor,
      selectedColorProp = _ref$selectedColor === void 0 ? 'tintGreen' : _ref$selectedColor,
      onClickProp = _ref.onClick,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      other = _objectWithoutProperties(_ref, ["size", "icon", "label", "isSelected", "disabled", "selectionColor", "selectedColor", "onClick", "color"]);

  var rippleRef = useRef(null);
  var iconRef = useRef(null);

  var _useSharedHoverContex = useSharedHoverContext(),
      onEnterTarget = _useSharedHoverContex.onEnterTarget,
      onLeaveTarget = _useSharedHoverContex.onLeaveTarget,
      enabled = _useSharedHoverContex.enabled; // support falling back to the deprecated prop name


  var selectedColor = selectionColor !== null && selectionColor !== void 0 ? selectionColor : selectedColorProp;

  function showRipple(e) {
    if (onClickProp) {
      onClickProp(e);
    }

    if (!isSelected) {
      rippleRef.current.onClick(e);
      scaleIcon(iconRef.current);
    }
  }

  var dimensions = size === 'medium' ? 32 : 24;

  function onMouseEnter(e) {
    onEnterTarget(e.currentTarget.getBoundingClientRect());
  }

  function onMouseLeave() {
    onLeaveTarget();
  }

  return /*#__PURE__*/React.createElement(StyledRippleIconToggle, _extends({
    $size: size,
    $color: color,
    $selectedColor: selectedColor,
    ref: forwardedRef,
    $isSelected: isSelected,
    $sharedHoverEnabled: enabled,
    onClick: showRipple,
    disabled: disabled
  }, mergeProps(other, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  })), /*#__PURE__*/React.createElement(VisuallyHidden, null, label), /*#__PURE__*/React.createElement(Ripple, {
    width: dimensions,
    height: dimensions,
    ref: rippleRef
  }), /*#__PURE__*/React.createElement(IconContainer, {
    ref: iconRef
  }, icon));
});

function scaleIcon(el) {
  el.animate([{
    transform: 'scale(0.9)'
  }, {
    transform: 'scale(1.15)'
  }, {
    transform: 'scale(1)'
  }], {
    duration: 200
  });
}

var StyledRippleIconToggle = styled.button.withConfig({
  displayName: "RippleIconToggle__StyledRippleIconToggle",
  componentId: "vapor__hz0rou-0"
})(["", ";", ";color:", ";will-change:transform;overflow:hidden;", "{color:", ";}", "{transition:background-color 100ms ", ",color 250ms ", ";}", " svg{will-change:transform;transition-duration:50ms;transition-timing-function:", ";transform:", ";}", " &[disabled]{color:", ";pointer-events:none;}"], baseIconButtonStyles, hoverStyles, theme.colors.icon.primary, whenHovered, theme.colors.icon.interactive.hover, whenActive, easeCurves.primary, easeCurves.primary, whenActive, easeCurves.primary, function (p) {
  return !p.$isSelected ? 'scale(0.9)' : 'scale(1)';
}, function (p) {
  return p.$isSelected && "\n    color: ".concat(theme.colors.palette[p.$selectedColor], ";\n    ").concat(whenActive, ", ").concat(whenHovered, " {\n      color: ").concat(theme.colors.palette[p.$selectedColor], ";\n    }\n  ");
}, theme.colors.icon.interactive.disabled);
var IconContainer = styled.div.withConfig({
  displayName: "RippleIconToggle__IconContainer",
  componentId: "vapor__hz0rou-1"
})(["width:", ";height:", ";"], theme.spaces[24], theme.spaces[24]);